import withCloseModal from './withCloseModal';
import Modal, { ModalHeader, ModalBody, ModalFooter } from './Modal';

const CloseableModal = withCloseModal(Modal);
CloseableModal.displayName = 'CloseableModal';
export default CloseableModal;
export { ModalHeader, ModalBody, ModalFooter };
